import { QnAWritePage } from "../Write/QnAWritePage";

export const NewQnAInquiry = () => <QnAWritePage mode="create" />;
